export default __webpack_public_path__ + "4d6dc2d4459649e69ac5f5fc47340ec0.webp";